'use client';

import { c as _c } from "react/compiler-runtime";
import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';
import { cn } from '@/lib/utils';
const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;
const PopoverContent = t0 => {
  const $ = _c(18);
  let className;
  let props;
  let ref;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      ref,
      className,
      align: t1,
      sideOffset: t2,
      portal: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  const align = t1 === undefined ? "center" : t1;
  const sideOffset = t2 === undefined ? 4 : t2;
  const portal = t3 === undefined ? true : t3;
  let t4;
  if ($[7] !== className) {
    t4 = cn("z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-popover-content-transform-origin]", className);
    $[7] = className;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== align || $[10] !== props || $[11] !== ref || $[12] !== sideOffset || $[13] !== t4) {
    t5 = <PopoverPrimitive.Content ref={ref} align={align} sideOffset={sideOffset} className={t4} {...props} />;
    $[9] = align;
    $[10] = props;
    $[11] = ref;
    $[12] = sideOffset;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const content = t5;
  let t6;
  if ($[15] !== content || $[16] !== portal) {
    t6 = portal ? <PopoverPrimitive.Portal>{content}</PopoverPrimitive.Portal> : content;
    $[15] = content;
    $[16] = portal;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger };